export default "__VITE_ASSET__CT9A9FQS__"